import { render, staticRenderFns } from "./CaseDetail.vue?vue&type=template&id=19c61355&scoped=true"
import script from "./CaseDetail.vue?vue&type=script&lang=js"
export * from "./CaseDetail.vue?vue&type=script&lang=js"
import style0 from "./CaseDetail.vue?vue&type=style&index=0&id=19c61355&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.4.25_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6_w4ow4wqgwsbk3quj5bombr2dpu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c61355",
  null
  
)

export default component.exports